/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/search-form.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../src/app/search-panel/services/search-form.service';
import * as import7 from '../../../../../src/app/search-panel/services/search-form-util.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../../../../../src/app/search-panel/services/date.service';
import * as import12 from '../../../../../src/app/search-panel/components/search-form-fulltext.component';
import * as import13 from './search-form-fulltext.component.ngfactory';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '../../../../../src/app/search-panel/components/search-form-date.component';
import * as import16 from './search-form-date.component.ngfactory';
import * as import17 from 'ng2-translate/src/translate.pipe';
import * as import18 from 'ng2-translate/src/translate.service';
import * as import19 from '../../../../../src/app/search-panel/components/search-form-keyword.component';
import * as import20 from './search-form-keyword.component.ngfactory';
import * as import21 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import24 from '@angular/common/src/directives/ng_for';
import * as import25 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import26 from '@angular/common/src/directives/ng_if';
import * as import27 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import28 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import29 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import30 from '@angular/common/src/directives/ng_switch';
import * as import31 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import32 from '@angular/forms/src/directives/control_container';
import * as import33 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_SearchFormComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SearchFormComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  subscription0:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.SearchFormComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_searchFormModel(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.searchFormModel = currValue;
      this._changes['searchFormModel'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if (changed) {
      this.context.ngOnChanges(this._changes);
      this._changes = {};
    } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.search.subscribe(_eventHandler.bind(view,'search'))); }
  }
}
var renderType_SearchFormComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SearchFormComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SearchFormComponent>;
  _SearchFormService_0_3:import6.SearchFormService;
  _SearchFormUtilService_0_4:import7.SearchFormUtilService;
  _SearchFormComponent_0_5:Wrapper_SearchFormComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormComponent_Host0,renderType_SearchFormComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-search-form',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SearchFormComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchFormService_0_3 = new import6.SearchFormService();
    this._SearchFormUtilService_0_4 = new import7.SearchFormUtilService(this.injectorGet(import11.DateService,this.parentIndex));
    this._SearchFormComponent_0_5 = new Wrapper_SearchFormComponent(this.compView_0.ref,this._SearchFormService_0_3,this._SearchFormUtilService_0_4);
    this.compView_0.create(this._SearchFormComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._SearchFormComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.SearchFormService) && (0 === requestNodeIndex))) { return this._SearchFormService_0_3; }
    if (((token === import7.SearchFormUtilService) && (0 === requestNodeIndex))) { return this._SearchFormUtilService_0_4; }
    if (((token === import0.SearchFormComponent) && (0 === requestNodeIndex))) { return this._SearchFormComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    if (this._SearchFormComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange)) { this.compView_0.markAsCheckOnce(); }
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SearchFormComponent_0_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SearchFormComponentNgFactory:import10.ComponentFactory<import0.SearchFormComponent> = new import10.ComponentFactory<import0.SearchFormComponent>('obpa-search-form',View_SearchFormComponent_Host0,import0.SearchFormComponent);
const styles_SearchFormComponent:any[] = ([] as any[]);
class View_SearchFormComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import12.SearchFormFulltextComponent>;
  _SearchFormFulltextComponent_4_3:import13.Wrapper_SearchFormFulltextComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent1,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'obpa-search-form-fulltext',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import13.View_SearchFormFulltextComponent0(this.viewUtils,this,4,this._el_4);
    this._SearchFormFulltextComponent_4_3 = new import13.Wrapper_SearchFormFulltextComponent(this.parentView.parentView.injectorGet(import6.SearchFormService,this.parentView.parentIndex));
    this._text_5 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_4.create(this._SearchFormFulltextComponent_4_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.SearchFormFulltextComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._SearchFormFulltextComponent_4_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = this.parentView.context.form.get('fulltext');
    this._SearchFormFulltextComponent_4_3.check_fulltextFormControl(currVal_4_0_0,throwOnChange,false);
    this._SearchFormFulltextComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_4.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent2 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  compView_7:import2.AppView<import15.SearchFormDateComponent>;
  _SearchFormDateComponent_7_3:import16.Wrapper_SearchFormDateComponent;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent2,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','form-horizontal'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n                ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_1,'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_3,'div',new import3.InlineArray2(2,'class','col-xs-6'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'obpa-search-form-date',new import3.InlineArray2(2,'dateID','single'),(null as any));
    this.compView_7 = new import16.View_SearchFormDateComponent0(this.viewUtils,this,7,this._el_7);
    this._SearchFormDateComponent_7_3 = new import16.Wrapper_SearchFormDateComponent(this.parentView.parentView.injectorGet(import6.SearchFormService,this.parentView.parentIndex));
    this._text_8 = this.renderer.createText((null as any),'\n                        ',(null as any));
    this.compView_7.create(this._SearchFormDateComponent_7_3.context);
    this._text_9 = this.renderer.createText(this._el_5,'\n                    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_3,'\n                ',(null as any));
    this._text_11 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._text_12 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._text_12,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.SearchFormDateComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._SearchFormDateComponent_7_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_7_0_0:any = 'single';
    this._SearchFormDateComponent_7_3.check_dateID(currVal_7_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_7_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('DATE')),'');
    this._SearchFormDateComponent_7_3.check_dateTitle(currVal_7_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_7_0_2:any = this.parentView.context.form.get('date.single');
    this._SearchFormDateComponent_7_3.check_dateFormControl(currVal_7_0_2,throwOnChange,false);
    this._SearchFormDateComponent_7_3.ngDoCheck(this,this._el_7,throwOnChange);
    this.compView_7.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_7.destroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_12,ctx);
  }
}
class View_SearchFormComponent3 extends import2.AppView<any> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  compView_7:import2.AppView<import15.SearchFormDateComponent>;
  _SearchFormDateComponent_7_3:import16.Wrapper_SearchFormDateComponent;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  compView_13:import2.AppView<import15.SearchFormDateComponent>;
  _SearchFormDateComponent_13_3:import16.Wrapper_SearchFormDateComponent;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _pipe_translate_0:import17.TranslatePipe;
  _pipe_translate_1:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent3,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._text_0 = this.renderer.createText((null as any),'\n            ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','form-horizontal'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n                ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_1,'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_3,'div',new import3.InlineArray2(2,'class','col-xs-6'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                        ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'obpa-search-form-date',new import3.InlineArray2(2,'dateID','from'),(null as any));
    this.compView_7 = new import16.View_SearchFormDateComponent0(this.viewUtils,this,7,this._el_7);
    this._SearchFormDateComponent_7_3 = new import16.Wrapper_SearchFormDateComponent(this.parentView.parentView.injectorGet(import6.SearchFormService,this.parentView.parentIndex));
    this._text_8 = this.renderer.createText((null as any),'\n                        ',(null as any));
    this.compView_7.create(this._SearchFormDateComponent_7_3.context);
    this._text_9 = this.renderer.createText(this._el_5,'\n                    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_3,'\n                    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_3,'div',new import3.InlineArray2(2,'class','col-xs-6'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'obpa-search-form-date',new import3.InlineArray2(2,'dateID','to'),(null as any));
    this.compView_13 = new import16.View_SearchFormDateComponent0(this.viewUtils,this,13,this._el_13);
    this._SearchFormDateComponent_13_3 = new import16.Wrapper_SearchFormDateComponent(this.parentView.parentView.injectorGet(import6.SearchFormService,this.parentView.parentIndex));
    this._text_14 = this.renderer.createText((null as any),'\n                        ',(null as any));
    this.compView_13.create(this._SearchFormDateComponent_13_3.context);
    this._text_15 = this.renderer.createText(this._el_11,'\n                    ',(null as any));
    this._text_16 = this.renderer.createText(this._el_3,'\n                ',(null as any));
    this._text_17 = this.renderer.createText(this._el_1,'\n            ',(null as any));
    this._text_18 = this.renderer.createText((null as any),'\n        ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._text_18,((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._text_18
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.SearchFormDateComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._SearchFormDateComponent_7_3.context; }
    if (((token === import15.SearchFormDateComponent) && ((13 <= requestNodeIndex) && (requestNodeIndex <= 14)))) { return this._SearchFormDateComponent_13_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_7_0_0:any = 'from';
    this._SearchFormDateComponent_7_3.check_dateID(currVal_7_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_7_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FROM DATE')),'');
    this._SearchFormDateComponent_7_3.check_dateTitle(currVal_7_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_7_0_2:any = this.parentView.context.form.get('date.from');
    this._SearchFormDateComponent_7_3.check_dateFormControl(currVal_7_0_2,throwOnChange,false);
    this._SearchFormDateComponent_7_3.ngDoCheck(this,this._el_7,throwOnChange);
    const currVal_13_0_0:any = 'to';
    this._SearchFormDateComponent_13_3.check_dateID(currVal_13_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_13_0_1:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('TO DATE')),'');
    this._SearchFormDateComponent_13_3.check_dateTitle(currVal_13_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_13_0_2:any = this.parentView.context.form.get('date.to');
    this._SearchFormDateComponent_13_3.check_dateFormControl(currVal_13_0_2,throwOnChange,false);
    this._SearchFormDateComponent_13_3.ngDoCheck(this,this._el_13,throwOnChange);
    this.compView_7.internalDetectChanges(throwOnChange);
    this.compView_13.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_7.destroy();
    this.compView_13.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._text_0,ctx);
    cb(this._el_1,ctx);
    cb(this._text_18,ctx);
  }
}
class View_SearchFormComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import19.SearchFormKeywordComponent>;
  _SearchFormKeywordComponent_2_3:import20.Wrapper_SearchFormKeywordComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent5,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','form-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'obpa-search-form-keyword',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import20.View_SearchFormKeywordComponent0(this.viewUtils,this,2,this._el_2);
    this._SearchFormKeywordComponent_2_3 = new import20.Wrapper_SearchFormKeywordComponent(this.parentView.parentView.parentView.injectorGet(import6.SearchFormService,this.parentView.parentView.parentIndex));
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_2.create(this._SearchFormKeywordComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.SearchFormKeywordComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SearchFormKeywordComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.$implicit;
    this._SearchFormKeywordComponent_2_3.check_keyword(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.parentView.context.form.get(('keywords.' + this.context.$implicit.id));
    this._SearchFormKeywordComponent_2_3.check_keywordFormControl(currVal_2_0_1,throwOnChange,false);
    this._SearchFormKeywordComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import14.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import21.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent4,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import14.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import21.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.injectorGet(import23.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import24.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.searchFormModel.keywords;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_SearchFormComponent5(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_SearchFormComponent7 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent7,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: noDate')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent8 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent8,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: noKeyword')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent9 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent9,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: noDateOrKeyword')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent10 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent10,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: noDateAndKeyword')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_SearchFormComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import14.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import25.Wrapper_NgIf;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import14.ViewContainer;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import25.Wrapper_NgIf;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _vc_10:import14.ViewContainer;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import25.Wrapper_NgIf;
  _text_11:any;
  _anchor_12:any;
  /*private*/ _vc_12:import14.ViewContainer;
  _TemplateRef_12_5:any;
  _NgIf_12_6:import25.Wrapper_NgIf;
  _text_13:any;
  /*private*/ _expr_26:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_SearchFormComponent6,renderType_SearchFormComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_26 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','alert alert-danger'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_6 = new import14.ViewContainer(6,0,this,this._anchor_6);
    this._TemplateRef_6_5 = new import22.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import25.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_8 = new import14.ViewContainer(8,0,this,this._anchor_8);
    this._TemplateRef_8_5 = new import22.TemplateRef_(this,8,this._anchor_8);
    this._NgIf_8_6 = new import25.Wrapper_NgIf(this._vc_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_10 = new import14.ViewContainer(10,0,this,this._anchor_10);
    this._TemplateRef_10_5 = new import22.TemplateRef_(this,10,this._anchor_10);
    this._NgIf_10_6 = new import25.Wrapper_NgIf(this._vc_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_12 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_12 = new import14.ViewContainer(12,0,this,this._anchor_12);
    this._TemplateRef_12_5 = new import22.TemplateRef_(this,12,this._anchor_12);
    this._NgIf_12_6 = new import25.Wrapper_NgIf(this._vc_12.vcRef,this._TemplateRef_12_5);
    this._text_13 = this.renderer.createText(this._el_0,' \n        ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._anchor_12,
      this._text_13
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import26.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import22.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import26.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import22.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import26.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    if (((token === import22.TemplateRef) && (12 === requestNodeIndex))) { return this._TemplateRef_12_5; }
    if (((token === import26.NgIf) && (12 === requestNodeIndex))) { return this._NgIf_12_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_6_0_0:any = this.parentView.context.form.hasError('noDate');
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    const currVal_8_0_0:any = this.parentView.context.form.hasError('noKeyword');
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    const currVal_10_0_0:any = this.parentView.context.form.hasError('noDateOrKeyword');
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.ngDoCheck(this,this._anchor_10,throwOnChange);
    const currVal_12_0_0:any = this.parentView.context.form.hasError('noDateAndKeyword');
    this._NgIf_12_6.check_ngIf(currVal_12_0_0,throwOnChange,false);
    this._NgIf_12_6.ngDoCheck(this,this._anchor_12,throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    this._vc_10.detectChangesInNestedViews(throwOnChange);
    this._vc_12.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_26:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: ERRORS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_4,currVal_26);
      this._expr_26 = currVal_26;
    }
  }
  destroyInternal():void {
    this._vc_6.destroyNestedViews();
    this._vc_8.destroyNestedViews();
    this._vc_10.destroyNestedViews();
    this._vc_12.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 6)) { return new View_SearchFormComponent7(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    if ((nodeIndex == 8)) { return new View_SearchFormComponent8(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    if ((nodeIndex == 10)) { return new View_SearchFormComponent9(this.viewUtils,this,10,this._anchor_10,this._vc_10); }
    if ((nodeIndex == 12)) { return new View_SearchFormComponent10(this.viewUtils,this,12,this._anchor_12,this._vc_12); }
    return (null as any);
  }
}
var renderType_SearchFormComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SearchFormComponent,{});
export class View_SearchFormComponent0 extends import2.AppView<import0.SearchFormComponent> {
  _el_0:any;
  _FormGroupDirective_0_3:import27.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import28.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import14.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import25.Wrapper_NgIf;
  _text_3:any;
  _el_4:any;
  _NgSwitch_4_3:import29.Wrapper_NgSwitch;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import14.ViewContainer;
  _TemplateRef_6_5:any;
  _NgSwitchCase_6_6:import29.Wrapper_NgSwitchCase;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import14.ViewContainer;
  _TemplateRef_8_5:any;
  _NgSwitchCase_8_6:import29.Wrapper_NgSwitchCase;
  _text_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import14.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import25.Wrapper_NgIf;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _vc_15:import14.ViewContainer;
  _TemplateRef_15_5:any;
  _NgIf_15_6:import25.Wrapper_NgIf;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  /*private*/ _expr_49:any;
  _pipe_translate_0:import17.TranslatePipe;
  /*private*/ _expr_51:any;
  _pipe_translate_1:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormComponent0,renderType_SearchFormComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckOnce);
    this._expr_49 = import1.UNINITIALIZED;
    this._expr_51 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'form',new import3.InlineArray4(4,'aria-describedby','obpa_form_err','novalidate',''),(null as any));
    this._FormGroupDirective_0_3 = new import27.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import14.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import25.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_4_3 = new import29.Wrapper_NgSwitch();
    this._text_5 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_6 = new import14.ViewContainer(6,4,this,this._anchor_6);
    this._TemplateRef_6_5 = new import22.TemplateRef_(this,6,this._anchor_6);
    this._NgSwitchCase_6_6 = new import29.Wrapper_NgSwitchCase(this._vc_6.vcRef,this._TemplateRef_6_5,this._NgSwitch_4_3.context);
    this._text_7 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_8 = new import14.ViewContainer(8,4,this,this._anchor_8);
    this._TemplateRef_8_5 = new import22.TemplateRef_(this,8,this._anchor_8);
    this._NgSwitchCase_8_6 = new import29.Wrapper_NgSwitchCase(this._vc_8.vcRef,this._TemplateRef_8_5,this._NgSwitch_4_3.context);
    this._text_9 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n    \n    ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_11 = new import14.ViewContainer(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import22.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import25.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'id','obpa_form_err'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_15 = new import14.ViewContainer(15,13,this,this._anchor_15);
    this._TemplateRef_15_5 = new import22.TemplateRef_(this,15,this._anchor_15);
    this._NgIf_15_6 = new import25.Wrapper_NgIf(this._vc_15.vcRef,this._TemplateRef_15_5);
    this._text_16 = this.renderer.createText(this._el_13,'\n    ',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','text-right'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n        ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'div',new import3.InlineArray2(2,'class','btn-group'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'button',new import3.InlineArray4(4,'class','btn btn-primary','type','submit'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'',(null as any));
    this._text_24 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_20,'button',new import3.InlineArray4(4,'class','btn btn-default','type','button'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_18,'\n    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_25,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_25));
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import26.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import30.NgSwitchCase) && (6 === requestNodeIndex))) { return this._NgSwitchCase_6_6.context; }
    if (((token === import22.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import30.NgSwitchCase) && (8 === requestNodeIndex))) { return this._NgSwitchCase_8_6.context; }
    if (((token === import30.NgSwitch) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 9)))) { return this._NgSwitch_4_3.context; }
    if (((token === import22.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import26.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    if (((token === import22.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import26.NgIf) && (15 === requestNodeIndex))) { return this._NgIf_15_6.context; }
    if (((token === import31.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import32.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._ControlContainer_0_4; }
    if (((token === import33.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.form;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this.context.searchFormModel.showFulltext;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = ((this.context.searchFormModel.dates == null)? (null as any): this.context.searchFormModel.dates.optionType);
    this._NgSwitch_4_3.check_ngSwitch(currVal_4_0_0,throwOnChange,false);
    this._NgSwitch_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_6_0_0:any = 2;
    this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0,throwOnChange,false);
    this._NgSwitchCase_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    const currVal_8_0_0:any = 3;
    this._NgSwitchCase_8_6.check_ngSwitchCase(currVal_8_0_0,throwOnChange,false);
    this._NgSwitchCase_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    const currVal_11_0_0:any = this.context.searchFormModel.keywords;
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    const currVal_15_0_0:any = (this.context.searchForm.showErrors && this.context.form.invalid);
    this._NgIf_15_6.check_ngIf(currVal_15_0_0,throwOnChange,false);
    this._NgIf_15_6.ngDoCheck(this,this._anchor_15,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    this._vc_15.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_0_5.checkHost(this,this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_49:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('SEARCH')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_49,currVal_49))) {
      this.renderer.setText(this._text_23,currVal_49);
      this._expr_49 = currVal_49;
    }
    valUnwrapper.reset();
    const currVal_51:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('RESET')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_51,currVal_51))) {
      this.renderer.setText(this._text_26,currVal_51);
      this._expr_51 = currVal_51;
    }
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_6.destroyNestedViews();
    this._vc_8.destroyNestedViews();
    this._vc_11.destroyNestedViews();
    this._vc_15.destroyNestedViews();
    this._FormGroupDirective_0_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_SearchFormComponent1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 6)) { return new View_SearchFormComponent2(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    if ((nodeIndex == 8)) { return new View_SearchFormComponent3(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    if ((nodeIndex == 11)) { return new View_SearchFormComponent4(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    if ((nodeIndex == 15)) { return new View_SearchFormComponent6(this.viewUtils,this,15,this._anchor_15,this._vc_15); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._FormGroupDirective_0_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'submit')) {
      const pd_sub_0:any = ((<any>this.context.onSubmit(this.context.form)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_25(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.onReset()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/search-form.component.ngfactory.ts